<div class="login-container">
  <div class="row g-0">
    <!-- Left Side -->
    <div class="col-md-6 left-side">
      <app-login-image></app-login-image>
    </div>

    <!-- Right Side - OTP Form -->
    <div class="col-md-6 d-flex justify-content-center align-items-center position-relative">
      <div class="otp-form">
        <app-logo></app-logo>
        <h2 class="login-title mt-5">Enter OTP Code</h2>

        <form #otpForm="ngForm" (keydown.enter)="twoFactorVerify({ page: 'otp-verification', form: otpForm })">
          <div class="col-12 text-center">
            <span class="noti">(We are sending One Time Password (OTP) to your email - {{ maskedEmail }})</span>
          </div>

          <!-- #region OTP Input with Validation -->
         <div class="alert alert-dismissible fade show alert-success py-2 mt-1 alert-sm" role="alert" *ngIf="displayMsg">
          <span class="fs-7">{{displayMsg}}</span>
          <button type="button" class="btn-close fs-7 pt-2" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>

          <div class="col-md-12 mt-4">
            <app-input [label]="'Enter One Time Password (OTP)'" 
                       [id]="'otp'" [name]="'otp'"
                       [required]="true" 
                       [(ngModel)]="otpDto.AuthenticatorCode" 
                       [validateNumber]="true" 
                       [maxlength]="6"
                       [minlength]="6" 
                       #otpInput="ngModel" 
                       [inputMode]="otpInput"></app-input>
            <span class="timer" *ngIf="!isResendEnabled">{{ getFormattedCountdown() }}</span>
          </div>
          <!-- #endregion -->
          
          <!-- #region resent button -->
          <div class="col-12 mt-1" (click)="resendOtp()">
            <ng-container *ngIf="isResentLoading; else resentBtn">
              Loading...
            </ng-container>

            <ng-template #resentBtn>
              <a  class="btn-resend" *ngIf="isResendEnabled" >Resend OTP?</a>
            </ng-template>
          </div>
          <!-- #endregion -->

          <!-- #region submit button -->
          <div class="col-md-12 mt-3">
            <app-button
                [buttonText]="'Submit'"                        
                [btnClassName]="'btn-login text-white'" 
                [page]="'otp-verification'" 
                [form]='otpForm'
                [buttonColor]="'#EF8936'"
                [disable]="isResentLoading"
                [loading]="isLoading"
                (buttonClick)="twoFactorVerify($event)">
            </app-button>
          </div>
          <!-- #endregion -->
        </form>
      </div>
    </div>
  </div>
</div>

<!-- <app-loading [isLoading]="isLoading"></app-loading> -->
